import React from "react";
import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";
export default function PhoneInputField({ phone, setPhone, inputClass = "" }) {
    const handlePhoneChange = (value, country, e, formattedValue) => {
        // Let the react-phone-input-2 library handle the formatting
        // Since we've configured it to only accept US numbers, it will handle the +1 correctly
        setPhone(value);
    };

    return (
        <PhoneInput
            buttonClass="tw-border-r tw-border-gray-300 tw-rounded-bl-[8px] tw-rounded-tl-[8px] tw-bg-gray-300 tw-hidden"
            inputClass={`tw-w-full tw-border tw-border-gray-300 tw-rounded-[8px] tw-pl-5  tw-h-[48px] tw-text-gray-700 tw-shadow-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-blue-500 ${inputClass}`}
            containerClass="tw-w-full tw-rounded-[8px]  tw-relative"
            country={"us"}
            placeholder="Enter phone number"
            value={phone || ""}
            onChange={handlePhoneChange}
            inputProps={{
                autoComplete: "tel",
            }}
            disableDropdown={true}
            countryCodeEditable={false}
            onlyCountries={["us"]}
            defaultCountry={"us"}
            enableSearch={false}
            disableSearchIcon={true}
            specialLabel=""
            autoFormat={true}
            disableCountryCode={false}
            priority={{ us: 0 }}
        />
    );
}
